// services/api.ts
import axios from "axios";

// Create axios instance
const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL || "https://api.rippleforge.org/public/api",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 30000,
  timeoutErrorMessage:
    "Request timeout. Please check your internet connection.",
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Get token directly from localStorage (avoid store import)
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - simplified to avoid store import
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized without importing store
    if (error.response?.status === 401) {
      console.log("Token expired or invalid, logging out...");

      // Clear token from localStorage
      localStorage.removeItem("token");

      // Redirect to login without importing store
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    // Handle timeout
    if (error.code === "ECONNABORTED") {
      return Promise.reject(
        new Error("Request timeout. Please check your internet connection.")
      );
    }

    // Handle network errors
    if (!error.response) {
      return Promise.reject(
        new Error("Network error. Please check your internet connection.")
      );
    }

    return Promise.reject(error);
  }
);

export default api;
